import axios from "axios";

const api = axios.create({
  // baseURL: "http://localhost:3000/v1",
  baseURL: "https://ec2-qurb.coleta.agr.br/v1",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

api.interceptors.request.use(async (config) => {
  const deviceId = localStorage.getItem("deviceId");

  if (deviceId) {
    config.headers["X-Device-ID"] = deviceId;
  }

  return config;
});

export const getMyFarms = async () => {
  return api
    .get("/app/farms")
    .then((response) => {
      return response.data;
    })
    .catch(() => null);
};

export const getAddressByCEP = async (cep: any) => {
  return axios
    .get(`https://viacep.com.br/ws/${cep}/json/`)
    .then((response) => {
      const addr =
        `${response.data.logradouro}, ${response.data.bairro}, ${response.data.localidade} - ${response.data.uf}, CEP ${response.data.cep}`
          .replace(", ,", "")
          .trim();

      if (addr.indexOf("undefined") !== -1) {
        return "";
      }

      return addr;
    })
    .catch(() => null);
};

export const getMyFarmsDetailed = async () => {
  return api
    .get("/app/farms-detailed")
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const fetchPull = async () => {
  return api
    .get("/app/pull")
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.error(err);
      return null;
    });
};

export const sfToken = async () => {
  return api
    .post("/json/sf")
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const getCollections = async () => {
  return api
    .get("/app/collections")
    .then((response) => response.data)
    .catch(() => null);
};

export const isDeviceAuthorized = async () => {
  return api
    .get("/app/profile")
    .then(() => {
      console.log("Dispositivo está autorizado!");
      localStorage.setItem("authorized", "true");
      return true;
    })
    .catch((err) => {
      console.error(err);
      if (err.response.status === 401) {
        localStorage.setItem("authorized", "false");
        console.log("Dispositivo não autorizado!");
      }

      return false;
    });
};

export const authentication = async () => {
  return api
    .get("/sso/request")
    .then((response) => response.data)
    .catch((error) => {
      console.error(error);
      return { url: "https://www.timacagro.com.br/?err=true" };
    });
};

export const getHighlights = async () => {
  return api
    .get("/app/highlights")
    .then((response) => {
      return response.data;
    })
    .catch((error) => []);
};

export const getProfileInformation = async () => {
  return api
    .get("/app/profile")
    .then((response) => response.data)
    .catch((error) => []);
};

export const createNewCollection = async (body: any, profile: any) => {
  if (!profile) {
    throw new Error("Profile not found");
  }

  const content = {
    ...body,
    email: profile.email,
    client: profile.name,
    _ctcData: {
      name: profile.name,
      pais: "BR",
      email: profile.email,
      title: "",
      userRole: "",
      department: "",
      supervisao: "",
    },
  };

  // Media Uploads
  // TODO: Check
  // console.log("Pushing offline collections");
  // const keys = _.keys(content);

  // for (const key of keys) {
  //   const value = content[key];
  //   if (Array.isArray(value)) {
  //     for (const item of value) {
  //       // Is uploadable media?
  //       if (item?.url && !item?.url?.startsWith("http")) {
  //         item.url = await AWSHelper.uploadFile(item.url);
  //       }
  //     }

  //     content[key] = _.filter(value, (el) => !_.isNil(el));
  //   }
  // }

  return api
    .post("/app/collections", content)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.error("Collection could not be created");
      throw err;
    });
};

export const requestMarketingContract = async (cId: any, inputValues: any) => {
  return api
    .post(`/legal/${cId}/send-contract`, inputValues)
    .then((response) => response.data);
};

export const login = async (email: any, password: any, deviceId: any) => {
  return api.post(`/auth/login`, {
    email: email.replace(/\s+/g, ""),
    password,
    deviceId,
  });
};
export const register = async (data: any, deviceId: any) => {
  return api.post(`/auth/register`, {
    ...data,
    email: data.email.replace(/\s+/g, ""),
    deviceId,
  });
};

export const updateCollection = async (id: any, body: any, profile: any) => {
  const content = {
    ...body,
    email: profile.email,
    client: profile.name,
    _ctcData: {
      name: profile.name,
      pais: "BR",
      email: profile.email,
      title: "",
      userRole: "",
      department: "",
      supervisao: "",
    },
  };

  // Media Uploads
  // TODO: check
  // const keys = _.keys(content);
  // for (const key of keys) {
  //   const value = content[key];
  //   if (Array.isArray(value)) {
  //     for (const item of value) {
  //       // Is uploadable media?
  //       if (item.url && !item.url.startsWith("http")) {
  //         item.url = await AWSHelper.uploadFile(item.url);
  //       }
  //     }
  //   }
  // }

  return api
    .post(`/app/collections/${id}`, content)
    .then((response) => response.data);
};

export const createReport = async (id: any, type: "pdf" | "png") => {
  return api
    .post(`/app/collections/${id}/reports/?type=${type}`)
    .then((response) => response.data);
};

export const downloadReport = async (
  id: any,
  reportId: any,
  type: "pdf" | "png"
) => {
  const response = await api.get(
    `/app/collections/${id}/reports/${reportId}/${type}`,
    {
      responseType: "arraybuffer",
    }
  );
  return response.data;
};

export const requestPasswordReset = async (email: string) => {
  return api.post("/auth/request-password-reset", { email });
};

export const resetPassword = async (password: string, token: string) => {
  return api.post("/auth/reset-password", { password, token });
};
